import WKT from 'ol/format/WKT';
import { Point } from 'ol/geom';

export const getCentroidByWKT = (centroidWKT: string) => {
    const wktReader = new WKT();
    const centroidGeometry = new WKT().readGeometry(centroidWKT);
    const centroid = (centroidGeometry as Point).getCoordinates();
    return [centroid[0], centroid[1]];
};